<template>
  <flex-layout
    class="button h-100 pt-2 pb-2"
    justify="center"
    align="center"
    @click="onContainerClick"
    @keyup.enter="onContainerClick"
  >
    <base-text class="mx-auto my-auto pt-1" size="sm" color="primary" justify="center" bold>
      {{ props.label }}
    </base-text>
    <base-icon
      v-if="props.menuItems.length"
      class="chevron"
      :class="{'chevron-transform': openMenu}"
      name="chevron-right"
    />
  </flex-layout>
</template>

<script setup lang="ts">

import { ref } from 'vue';
import BaseText from '@/components/Texts/BaseText.vue';
import FlexLayout from '@/components/Layouts/FlexLayout.vue';
import BaseIcon from '@/components/Images/BaseIcon.vue';
import BaseMenu from '@/components/Layouts/BaseMenu.vue';
import { useRouter } from 'vue-router';

interface MenuItem {
  text: string;
  route: string;
}

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  route: {
    type: String,
    required: false,
  },
  menuItems: {
    type: Array as () => MenuItem[],
    required: false,
    default: () => [],
  },
});

const router = useRouter();
const openMenu = ref(false);
const emit = defineEmits<{(key: 'click', value: void): void}>();

function onContainerClick() {
  emit('click');
  if (props.route) router.push({ name: props.route });
}

</script>

<style scoped>
.button {
  width: 200px;
  max-width: 200px;
  cursor: pointer;
  position: relative;
  transition: .3s ease-in-out;
}

.button:hover{
  background: var(--grayLight);
}
.chevron {
  color: var(--primary);
  position: absolute;
  margin-top: auto;
  margin-bottom: auto;
  right: 10px;
  transition: .3s ease-in-out;
}
.chevron-transform {
  transform: rotate(90deg);
}

.menu {
  background-color: var(--offWhite);
  filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.059));
}

.menu-item {
  position: relative;
  height: 55px;

}
.menu-item:hover {
  cursor: pointer;
  background: var(--grayLight);

}

</style>
